// //pages/ProfileSettings.tsx


import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { getUserProfileImage, getUserProfileText, getPreferredUsername, update_preferred_username, uploadImageToLambda, updateUserProfileWithoutImage,getUserProfileImageByuserSubCF } from '../utils/userProfileApi';
import { userPool } from '../services/cognitoConfig';
import { CognitoUserSession, CognitoUser } from 'amazon-cognito-identity-js';
import { Button, TextField, Box, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { useNavigate } from 'react-router-dom';
import { Cropper } from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { useAppTokens } from '../context/ThemeModeContext';

const ProfileSettings: React.FC = () => {
    const TOKENS = useAppTokens();
    const { isLoggedIn } = useAuth();
    const [profileImage, setProfileImage] = useState<File | null>(null);
    const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);
    const [name, setPreferredName] = useState<string>('');
    const [bio, setBio] = useState<string>('');
    const [croppedImage, setCroppedImage] = useState<string | null>(null);
    const [croppedBlob, setCroppedBlob] = useState<Blob | null>(null);
    const [isCropperOpen, setIsCropperOpen] = useState<boolean>(false);
    const cropperRef = useRef<HTMLImageElement>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfileData = async () => {
            if (isLoggedIn) {
                const cognitoUser: CognitoUser | null = userPool.getCurrentUser();
                if (cognitoUser) {
                    cognitoUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
                        if (err) {
                            console.error('Error getting session:', err);
                            return;
                        }
                        if (session) {
                            const idToken = session.getIdToken().getJwtToken();
                            const userSub = session.getIdToken().payload.sub;
                            // getUserProfileImage(userSub, idToken).then(response => {
                            //     if (response && response.profileImage) {
                            //         setProfileImageUrl(response.profileImage);
                            //     }
                            // }).catch(error => {
                            //     console.error('Error fetching profile image:', error);
                            // });
                            getUserProfileImageByuserSubCF(userSub).then(response => {
                                if (response && response) {
                                    setProfileImageUrl(response);
                                }
                            }).catch(error => {
                                console.error('Error fetching profile image:', error);
                            });




                            getUserProfileText(userSub, idToken).then(response => {
                                if (response && response.profileText) {
                                    setBio(response.profileText);
                                }
                            
                            }).catch(error => {
                                console.error('Error fetching profile text:', error);
                            });

                            getPreferredUsername(userSub, idToken).then(response => {
                                if (response && response.preferred_name) {
                                    setPreferredName(response.preferred_name);
                                }
                            }).catch(error => {
                                console.error('Error fetching preferred username:', error);
                            });
                        }
                    });
                }
            }
        };

        fetchProfileData();
    }, [isLoggedIn]);

    const handleProfileImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setProfileImage(file);
            setProfileImageUrl(URL.createObjectURL(file)); // ローカルプレビュー用にURLを設定
            setIsCropperOpen(true); // クロッパーダイアログを開く
        }
    };

    // 選択中の（自由に位置・大きさを変えられる）正方形クロップ範囲を、
    // 実際にドラッグ・リサイズされたピクセルサイズのままcanvasとして取得する
    const getCroppedCanvas = (): HTMLCanvasElement | null => {
        if (!cropperRef.current) return null;
        const cropper = (cropperRef.current as any).cropper;
        return cropper.getCroppedCanvas();
    };

    const handleCrop = () => {
        const canvas = getCroppedCanvas();
        if (canvas) {
            setCroppedImage(canvas.toDataURL('image/jpeg', 0.9)); // プレビュー用にBase64として保存
            // 保存時にcropperRef.currentへ再アクセスすると、ダイアログを閉じた時点で
            // Cropperがアンマウントされrefがnullに戻ってしまうため、Blobはこの時点で確定させておく
            canvas.toBlob((blob) => {
                setCroppedBlob(blob);
            }, 'image/jpeg', 0.9);
            setIsCropperOpen(false); // クロッパーダイアログを閉じる
        }
    };

    // const handleSaveProfile = async () => {
    //     const cognitoUser: CognitoUser | null = userPool.getCurrentUser();
    //     if (cognitoUser) {
    //         cognitoUser.getSession(async (err: Error | null, session: CognitoUserSession | null) => {
    //             if (err) {
    //                 console.error('Error getting session:', err);
    //                 return;
    //             }
    //             if (session) {
    //                 const idToken = session.getIdToken().getJwtToken();
    //                 const userSub = session.getIdToken().payload.sub;

    //                 // プロフィール画像のURLの初期値を設定
    //                 let profileImageUrlToUpdate = profileImageUrl;

    //                 // 画像が選択されていてクロップされた場合は、canvasから直接Blobを作成
    //                 if (croppedImage && cropperRef.current) {
    //                     const cropper = (cropperRef.current as any).cropper;
    //                     cropper.getCroppedCanvas().toBlob(async (blob: Blob | null) => {
    //                         if (blob) {
    //                             const file = new File([blob], 'cropped_image.jpg', { type: 'image/jpeg' });
    //                             profileImageUrlToUpdate = await uploadImageToLambda(file, userSub, idToken);
    //                             if (!profileImageUrlToUpdate) {
    //                                 console.error('Failed to upload profile image');
    //                                 return;
    //                             }
    //                             // プロフィール情報を更新
    //                             await updateUserProfileWithoutImage(userSub, bio, idToken);
    //                             await update_preferred_username(userSub, name, idToken);
    //                             navigate('/');
    //                         }
    //                     }, 'image/jpeg');
    //                 } else {
    //                     // 画像が選択されていない場合、既存の画像URLで更新
    //                     await updateUserProfileWithoutImage(userSub, bio, idToken);
    //                     await update_preferred_username(userSub, name, idToken);
    //                     navigate('/');
    //                 }
    //             }
    //         });
    //     }
    // };

    const handleSaveProfile = async () => {
        const cognitoUser: CognitoUser | null = userPool.getCurrentUser();
        if (cognitoUser) {
            cognitoUser.getSession(async (err: Error | null, session: CognitoUserSession | null) => {
                if (err) {
                    console.error('Error getting session:', err);
                    return;
                }
                if (session) {
                    const idToken = session.getIdToken().getJwtToken();
                    const userSub = session.getIdToken().payload.sub;
    
                    // プロフィール画像のURLの初期値を設定
                    let profileImageUrlToUpdate = profileImageUrl;
    
                    try {
                        // クロップ済みのBlob（handleCrop時点で、選んだ出力サイズにリサイズ済み）があれば
                        // それをアップロードする
                        if (croppedBlob) {
                            const file = new File([croppedBlob], 'cropped_image.jpg', { type: 'image/jpeg' });
                            profileImageUrlToUpdate = await uploadImageToLambda(file, userSub, idToken);
                            if (!profileImageUrlToUpdate) {
                                console.error('Failed to upload profile image');
                                return;
                            }
                        }

                        // プロフィール情報を更新
                        await updateUserProfileWithoutImage(userSub, bio, idToken);
                        await update_preferred_username(userSub, name, idToken);
    
                        // すべての処理が完了した後、自分のプロフィールページへ戻る
                        navigate(`/${cognitoUser.getUsername()}`);
                    } catch (error) {
                        console.error('Error updating profile:', error);
                    }
                }
            });
        }
    };
    
    

    const fieldSx = {
        mb: 2.5,
        '& .MuiOutlinedInput-root': {
            color: TOKENS.text,
            background: TOKENS.buttonBg,
            borderRadius: '12px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: TOKENS.borderSoft
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: TOKENS.accent
        },
        '& .MuiInputLabel-root': {
            color: TOKENS.textSub
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: TOKENS.text
        }
    };

    return (
        <Box
            sx={{
                mt: 7,
                minHeight: 'calc(100vh - 56px)',
                background: TOKENS.bg,
                py: { xs: 4, md: 6 },
                px: 2
            }}
        >
            <Box sx={{ maxWidth: 560, margin: 'auto' }}>
                <Typography sx={{ fontSize: 22, fontWeight: 700, color: TOKENS.text, mb: 0.5 }}>
                    プロフィール設定
                </Typography>
                <Typography sx={{ fontSize: 13, color: TOKENS.textSub, mb: 3 }}>
                    公開ビューであなたが他のユーザーにどう見えるかを決める情報です
                </Typography>

                <Box
                    sx={{
                        border: `1px solid ${TOKENS.border}`,
                        background: TOKENS.glass,
                        borderRadius: '20px',
                        p: { xs: 2.5, md: 3.5 }
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 3.5 }}>
                        <Box sx={{ position: 'relative' }}>
                            <Avatar
                                src={croppedImage || profileImageUrl || ''}
                                alt="User Profile"
                                sx={{
                                    width: 88,
                                    height: 88,
                                    border: `2px solid ${TOKENS.borderSoft}`,
                                    boxShadow: `0 4px 18px ${TOKENS.radialGlow}`
                                }}
                            />
                            <Button
                                component="label"
                                sx={{
                                    position: 'absolute',
                                    right: -4,
                                    bottom: -4,
                                    minWidth: 0,
                                    width: 34,
                                    height: 34,
                                    borderRadius: '50%',
                                    background: TOKENS.buttonBg,
                                    border: `1px solid ${TOKENS.border}`,
                                    color: TOKENS.text,
                                    '&:hover': { background: TOKENS.buttonBgHover }
                                }}
                            >
                                <PhotoCameraIcon sx={{ fontSize: 16 }} />
                                <input type="file" hidden onChange={handleProfileImageChange} />
                            </Button>
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 15, fontWeight: 600, color: TOKENS.text }}>
                                {name || 'ユーザー名未設定'}
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: TOKENS.textSub }}>
                                アイコンをクリックして画像を変更
                            </Typography>
                        </Box>
                    </Box>

                    <TextField
                        label="ユーザー名"
                        fullWidth
                        variant="outlined"
                        value={name}
                        onChange={(e) => setPreferredName(e.target.value)}
                        sx={fieldSx}
                    />
                    <TextField
                        label="自己紹介"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={4}
                        value={bio}
                        onChange={(e) => setBio(e.target.value)}
                        sx={{ ...fieldSx, mb: 3.5 }}
                    />

                    <Button
                        fullWidth
                        onClick={handleSaveProfile}
                        sx={{
                            borderRadius: '999px',
                            py: 1.1,
                            fontSize: 14,
                            fontWeight: 700,
                            textTransform: 'none',
                            color: TOKENS.bg,
                            background: TOKENS.text,
                            '&:hover': { background: TOKENS.textSub }
                        }}
                    >
                        完了
                    </Button>
                </Box>
            </Box>

            <Dialog open={isCropperOpen} onClose={() => setIsCropperOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>画像を切り取る</DialogTitle>
                <DialogContent>
                    {profileImageUrl && (
                        <Cropper
                            src={profileImageUrl}
                            style={{ height: 400, width: '100%' }}
                            initialAspectRatio={1}
                            aspectRatio={1}
                            guides={true}
                            ref={cropperRef}
                        />
                    )}
                    <Typography sx={{ fontSize: 12, color: TOKENS.textSub, mt: 1.5 }}>
                        枠をドラッグして位置を、四隅をドラッグして大きさを調整できます（常に正方形）
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsCropperOpen(false)}>キャンセル</Button>
                    <Button onClick={handleCrop} color="primary">切り取る</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ProfileSettings;
